import { useCallback, useEffect, useState } from "react";
import * as usuariosApi from "../api/usuarios";

// Carrega usuários da instituição (lista para selects/buscas).
// Padroniza payload backend → shape esperado pela UI legada (`user` = login string).
export function useUsuariosInstituicao(instituicaoId) {
  const [usuarios, setUsuarios] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);

  const recarregar = useCallback(async () => {
    if (!instituicaoId) {
      setUsuarios([]);
      setCarregando(false);
      return;
    }
    setCarregando(true);
    setErro(null);
    try {
      const lista = await usuariosApi.listarUsuarios(instituicaoId);
      const adaptado = (Array.isArray(lista) ? lista : []).map((u) => ({
        ...u,
        // UI legada exibe e busca por "user" (matrícula/login)
        user: u.user || u.email || String(u.id),
        faculdadeId: u.faculdadeId || u.instituicaoId || instituicaoId,
      }));
      setUsuarios(adaptado);
    } catch (err) {
      setErro(err);
      setUsuarios([]);
    } finally {
      setCarregando(false);
    }
  }, [instituicaoId]);

  useEffect(() => {
    recarregar();
  }, [recarregar]);

  return { usuarios, carregando, erro, recarregar };
}
